module.exports = __webpack_public_path__ + "img/goto-meeting.07dc0351.jpeg";